export default class Slideshow {
  constructor() {
    $(window).on('load', () => {
      $('.slideshow').slick({
        dots: true
      });
    });
  }
}